import { reputationData } from '@/mocks/about';

export default function Reputation() {
  return (
    <section id="reputation" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            口碑与荣誉
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            来自用户的认可和行业的肯定，是我们不断前进的动力
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-16">
          {reputationData.stats.map((stat) => (
            <div key={stat.label} className="text-center p-6 rounded-lg bg-background-50 border border-background-200/60">
              <div className="text-2xl md:text-3xl font-bold text-accent-600 mb-2">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-foreground-600">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        <div className="mb-16">
          <h3 className="text-lg font-semibold text-foreground-950 mb-6 text-center">
            行业奖项
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {reputationData.awards.map((award) => (
              <div
                key={award.title}
                className="p-5 rounded-lg bg-background-50 border border-background-200/60 text-center"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-3">
                  <i className="ri-award-line text-lg"></i>
                </div>
                <h4 className="text-sm font-semibold text-foreground-950 mb-1">
                  {award.title}
                </h4>
                <p className="text-xs text-foreground-500">
                  {award.org} · {award.year}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div>
          <h3 className="text-lg font-semibold text-foreground-950 mb-6 text-center">
            合作伙伴
          </h3>
          <div className="flex flex-wrap justify-center gap-4">
            {reputationData.partners.map((partner) => (
              <span
                key={partner}
                className="px-5 py-2.5 text-sm rounded-full bg-background-50 border border-background-200/60 text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-all duration-200 cursor-default"
              >
                {partner}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}